var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"pa-2"},[_c('v-card-title',{staticClass:"pt-0 pb-0 justify-center"},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":30}})],1),_c('v-card-title',{staticClass:"pt-0 pb-0 justify-center"},[_vm._v(_vm._s(_vm.message))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }